/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CursorHookPayload,
  CursorHookPayload$Outbound,
  CursorHookPayload$outboundSchema,
} from "../components/cursorhookpayload.js";

export type HooksNumberCursorSecurityOption1 = {
  deviceAgentTokenHeaderAuthorization: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberCursorSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type HooksNumberCursorSecurity = {
  option1?: HooksNumberCursorSecurityOption1 | undefined;
  option2?: HooksNumberCursorSecurityOption2 | undefined;
};

export type HooksNumberCursorRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Optional endpoint hostname supplied by the Speakeasy hook plugin.
   */
  xGramHookHostname?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  cursorHookPayload: CursorHookPayload;
};

/** @internal */
export type HooksNumberCursorSecurityOption1$Outbound = {
  device_agent_token_header_Authorization: string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberCursorSecurityOption1$outboundSchema: z.ZodMiniType<
  HooksNumberCursorSecurityOption1$Outbound,
  HooksNumberCursorSecurityOption1
> = z.pipe(
  z.object({
    deviceAgentTokenHeaderAuthorization: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      deviceAgentTokenHeaderAuthorization:
        "device_agent_token_header_Authorization",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCursorSecurityOption1ToJSON(
  hooksNumberCursorSecurityOption1: HooksNumberCursorSecurityOption1,
): string {
  return JSON.stringify(
    HooksNumberCursorSecurityOption1$outboundSchema.parse(
      hooksNumberCursorSecurityOption1,
    ),
  );
}

/** @internal */
export type HooksNumberCursorSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const HooksNumberCursorSecurityOption2$outboundSchema: z.ZodMiniType<
  HooksNumberCursorSecurityOption2$Outbound,
  HooksNumberCursorSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCursorSecurityOption2ToJSON(
  hooksNumberCursorSecurityOption2: HooksNumberCursorSecurityOption2,
): string {
  return JSON.stringify(
    HooksNumberCursorSecurityOption2$outboundSchema.parse(
      hooksNumberCursorSecurityOption2,
    ),
  );
}

/** @internal */
export type HooksNumberCursorSecurity$Outbound = {
  Option1?: HooksNumberCursorSecurityOption1$Outbound | undefined;
  Option2?: HooksNumberCursorSecurityOption2$Outbound | undefined;
};

/** @internal */
export const HooksNumberCursorSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberCursorSecurity$Outbound,
  HooksNumberCursorSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => HooksNumberCursorSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => HooksNumberCursorSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function hooksNumberCursorSecurityToJSON(
  hooksNumberCursorSecurity: HooksNumberCursorSecurity,
): string {
  return JSON.stringify(
    HooksNumberCursorSecurity$outboundSchema.parse(hooksNumberCursorSecurity),
  );
}

/** @internal */
export type HooksNumberCursorRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "X-Gram-Hook-Hostname"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  CursorHookPayload: CursorHookPayload$Outbound;
};

/** @internal */
export const HooksNumberCursorRequest$outboundSchema: z.ZodMiniType<
  HooksNumberCursorRequest$Outbound,
  HooksNumberCursorRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    xGramHookHostname: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    cursorHookPayload: CursorHookPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      xGramHookHostname: "X-Gram-Hook-Hostname",
      idempotencyKey: "Idempotency-Key",
      cursorHookPayload: "CursorHookPayload",
    });
  }),
);

export function hooksNumberCursorRequestToJSON(
  hooksNumberCursorRequest: HooksNumberCursorRequest,
): string {
  return JSON.stringify(
    HooksNumberCursorRequest$outboundSchema.parse(hooksNumberCursorRequest),
  );
}
